<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Currently cleared</h4>
            <div>
              <div
                class="my-2 p-2"
                style="border: 1px solid #0d6efd; color: #0d6efd"
              >
                Taico Associates,Perfode HR Solutions
              </div>
              <b-button class="buttonStyle mt-2" variant="primary"
                >Clear all logins</b-button
              >
              <br />
              <p class="my-2">
                Note: this does nothing but reset the application var for
                tracking. It does not affect the cache.
              </p>
              <hr />
            </div>
            <div>
              <h6 class="my-3">Login Links</h6>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <b>
                    <span class="text-success">10</span>
                    Records found
                  </b>
                </div>
                <div
                  class="
                    col-xs-12 col-sm-6 col-md-6 col-lg-6
                    form-inline
                    justify-content-end
                  "
                >
                  <b>Records per Screen</b>
                  <b-form-select
                    class="mx-2"
                    v-model="filterRecordsPerScreen"
                    :options="filterRecordsPerScreenOptions"
                  ></b-form-select>
                </div>
              </div>
              <b-table
                class="my-2"
                responsive
                :items="loginLinkItems"
                :fields="loginLinkFields"
              >
                <template v-slot:cell(login)="">
                  <b-button class="buttonStyle" size="sm" variant="primary"
                    >Login</b-button
                  >
                </template>
              </b-table>
            </div>
            <div class="row my-2">
              <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                <label>Viewing 1 - 10 of 10 records </label>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-button-group class="float-right">
                  <b-button>&#60;&#60;</b-button>
                  <b-button>Prev</b-button>
                  <b-button>1</b-button>
                  <b-button>Next</b-button>
                  <b-button>>></b-button>
                </b-button-group>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
export default {
  name: "preLogin",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
  },
  data() {
    return {
      loginLinkItems: [
        {
          name: "Taico",
          user_name: "Tai",
          cleared: "Yes",
        },
        {
          name: "Taico",
          user_name: "Tai",
          cleared: "Yes",
        },
        {
          name: "Taico",
          user_name: "Tai",
          cleared: "Yes",
        },
      ],
      loginLinkFields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "user_name",
          sortable: true,
        },
        {
          key: "login",
        },
        {
          key: "cleared",
          sortable: true,
        },
      ],
      filterRecordsPerScreen: 3,
    };
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : "preLogin",
        activeMenu: this.activeMenu ? this.activeMenu : "utilities",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.setActiveMenuItem();
    this.scrollToTop();
  },

  computed: {
    filterRecordsPerScreenOptions() {
      return this.$store.getters[
        "batchProcess/getFilterRecordsPerScreenOptions"
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
html,
body {
  height: 100%;
}

.buttonStyle {
  border-radius: 1.5rem;
  // padding: 10px 20px;
}
</style>
